export default function isMobileDevice() {
        if (typeof navigator === 'undefined' || typeof window === 'undefined') {
                return false;
        }

        const userAgent = navigator.userAgent || navigator.vendor || '';
        const isElectron = userAgent.toLowerCase().includes('electron') ||
                (typeof process !== 'undefined' && process.versions && process.versions.electron);
        if (isElectron) {
                return false;
        }

        const mobileRegex = /android|iphone|ipad|ipod|mobile/i;
        const isMobileUA = mobileRegex.test(userAgent);

        const isCoarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
        const isNarrow = window.innerWidth <= 768;

        return isMobileUA || isCoarse || isNarrow;
}
